import { render, staticRenderFns } from "./VisualizarPeriodoFormacaoDialog.vue?vue&type=template&id=3d92953a&scoped=true"
import script from "./VisualizarPeriodoFormacaoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarPeriodoFormacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarPeriodoFormacaoDialog.vue?vue&type=style&index=0&id=3d92953a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d92953a",
  null
  
)

export default component.exports